import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { AppPath } from '../../../AppPath'
import { CheckoutRouter } from '../checkout'
import { ProposalConfigurationPage } from '../configuration'
import { DisclosureRouter, ProposalUpgradePage } from '../disclosure'
import { PaymentRouter } from '../payment'
import { ProposalPath } from '../ProposalPath'

export const ProposalQuoteRoutes: FunctionComponent = () => (
  <Routes>
    {/* Configuration Journey */}

    <Route index element={<ProposalConfigurationPage />} />

    {/* Disclosure Journey */}

    <Route
      path={ProposalPath.DISCLOSURE + AppPath.WILDCARD}
      element={<DisclosureRouter />}
    />

    <Route path={ProposalPath.UPGRADE} element={<ProposalUpgradePage />} />

    {/* Checkout Journey */}

    <Route path={ProposalPath.CHECKOUT + AppPath.WILDCARD} element={<CheckoutRouter />} />

    {/* Payment Journey */}

    <Route path={ProposalPath.PAYMENT + AppPath.WILDCARD} element={<PaymentRouter />} />

    {/* Fallthrough */}

    <Route path='*' element={<Navigate to={AppPath.HOME} />} />
  </Routes>
)
